import { useState } from "react";
import { downloadExcelEvent } from "../../_events/products/download_report.event";
import { message } from "antd";

export const useDownloadExcelproducts = () => {

    const [ loading, setLoading ] = useState(false);

    const downloadExcel = () => {
        setLoading(true);
        downloadExcelEvent()
        .then(json => {
            setLoading(false);
        })
        .catch(err => {
            setLoading(false);
            message.error(err.message);
        });   
    }

    return {
        loading,
        downloadExcel,
    };

}